module.exports = __webpack_public_path__ + "img/works_mixi_xflag_4.5ce59d2c.png";